const Hero = () => {
  const stats = [
    { value: '500+', label: 'Chantiers réalisés' },
    { value: '15+',  label: "Ans d'expérience" },
    { value: 'RGE',  label: 'Certifié EnR' },
    { value: '100%', label: 'Satisfaction client' },
  ];

  return (
    <section className="hero" id="accueil">
      <div className="hero-bg" />

      <div className="hero-inner">
        <div className="hero-badge">
          <span className="hero-badge-dot" />
          Artisan certifié RGE — Loiret
        </div>

        <h1 className="hero-title">
          Expert en Plomberie,<br />
          Chauffage &{' '}
          <span className="hero-title-accent">Énergies<br />Renouvelables</span>
        </h1>

        <p className="hero-subtitle">
          Tramenergie intervient pour tous vos projets : installation de salles de bain
          clé en main, systèmes de chauffage, climatisation et pompes à chaleur
          avec éligibilité aux aides de l'État.
        </p>

        <div className="hero-ctas">
          <a href="#contact" className="btn btn-accent">Demander un devis gratuit</a>
          <a href="#services" className="btn btn-outline-dark">Découvrir nos services</a>
        </div>

        <div className="hero-stats">
          {stats.map(({ value, label }) => (
            <div key={label} className="hero-stat">
              <div className="hero-stat-value">{value}</div>
              <div className="hero-stat-label">{label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
